module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-02@2x.c6059e7d.jpg";